import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusIcon, EyeIcon, EditIcon } from 'lucide-react';
import { DataTable, Column } from '../components/DataTable';
import { StatusBadge } from '../components/StatusBadge';
import { mockSuppliers } from '../data/mockData';
import { Supplier } from '../types';
function getSupplierStatus(supplier: Supplier): string {
  if (supplier.contractExpiry) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const expiry = new Date(supplier.contractExpiry);
    if (expiry < today && supplier.status !== 'Blacklisted') {
      return 'Expired';
    }
  }
  return supplier.status;
}
export function SupplierList() {
  const navigate = useNavigate();
  const columns: Column<Supplier>[] = [{
    key: 'code',
    label: 'Supplier Code'
  }, {
    key: 'name',
    label: 'Supplier Name',
    render: s => <span className="font-medium text-gray-900" data-id="element-2933">{s.name}</span>
  }, {
    key: 'type',
    label: 'Type'
  }, {
    key: 'category',
    label: 'Category'
  }, {
    key: 'countryOfOrigin',
    label: 'Country'
  }, {
    key: 'contractExpiry',
    label: 'Contract Expiry',
    render: s => {
      if (!s.contractExpiry) return <span className="text-gray-400" data-id="element-2934">—</span>;
      const isExpired = new Date(s.contractExpiry) < new Date();
      return <span className={isExpired ? 'text-red-600 font-medium' : 'text-gray-700'} data-id="element-2935">
            {s.contractExpiry}
          </span>;
    }
  }, {
    key: 'contactPersonName',
    label: 'Contact Person'
  }, {
    key: 'status',
    label: 'Status',
    render: s => <StatusBadge status={getSupplierStatus(s)} data-id="element-2936" />
  }];
  return <div className="space-y-6 h-full flex flex-col" data-id="element-2937">
      <div className="flex items-center justify-between" data-id="element-2938">
        <div data-id="element-2939">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-2940">
            Supplier Management
          </h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-2941">
            Manage registered suppliers, their details, and statuses.
          </p>
        </div>
        <button onClick={() => navigate('/suppliers/create')} className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-2942">
          <PlusIcon className="h-4 w-4 mr-2" data-id="element-2943" />
          New Supplier
        </button>
      </div>

      <div className="flex-1" data-id="element-2944">
        <DataTable columns={columns} data={mockSuppliers} keyExtractor={item => item.id} searchPlaceholder="Search suppliers by name, code, or country..." onRowClick={item => navigate(`/suppliers/${item.id}/edit`)} actions={item => <div className="flex space-x-3 justify-end" data-id="element-2946">
              <button onClick={() => navigate(`/suppliers/${item.id}/edit`)} className="text-indigo-600 hover:text-indigo-900" data-id="element-2947">
                <EditIcon className="h-4 w-4" data-id="element-2948" />
              </button>
            </div>} data-id="element-2945" />
      </div>
    </div>;
}